import { Routes } from '@angular/router';
import { HomeComponent } from '../views/home/home.component';
import { NotFoundComponent } from '../views/not-found/not-found.component';
import { authGuard } from '@app/guards/auth.guard';
import { UnauthorizedComponent } from '@app/views/unauthorized/unauthorized.component';

export const routes: Routes = [
	{ path: 'evaluation/:evaluationId', component: HomeComponent, canActivate: [authGuard] },
	{ path: 'unauthorized', component: UnauthorizedComponent },
	{ path: '**', component: NotFoundComponent },
];
